import useGetRelatedProducts from '../../Hooks/useGetRelatedProducts'
import useGetSimilarProducts from '../../Hooks/useGetSimilarProducts'
import useGetProductsBySerial from '../../Hooks/useGetProductsBySerial'
import CustomSwiper from '../../../../Components/Components/CustomSwiper'
import LoadingSpinner from '../../../../Components/Components/LoadingSpinner'

const elementsInPage = 12

export const RelatedProducts = ({ product, isMobile, maxWidth }) => {
    const { relatedProducts, isRelatedProductsLoading } = useGetRelatedProducts(product)
    let width = isMobile ? '500px' : maxWidth

    if (isRelatedProductsLoading) {
        return <LoadingSpinner />
    }
    if (!relatedProducts || relatedProducts.length === 0) {
        return null
    }
    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={relatedProducts.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

// export const SimilarProducts = ({ product }) => {
//     const { similarProducts } = useGetSimilarProducts(product)
//     return (
//         similarProducts && similarProducts.slice(0, elementsInPage).map((similar, index) => (
//             <div key={index} className='col-3'>
//                 <ProductLight product={similar} />
//             </div>
//         ))
//     )
// }

export const SimilarProducts = ({ product, isMobile, maxWidth }) => {
    const { similarProducts, isSimilarProductsLoading } = useGetSimilarProducts(product)
    let width = isMobile ? '500px' : maxWidth

    if (isSimilarProductsLoading) {
        return <LoadingSpinner />
    }
    if (!similarProducts || similarProducts.length === 0) {
        return null
    }

    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={similarProducts.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

export const ProductsWithSameSerial = ({ product, isMobile, maxWidth }) => {
    const { productsWithSameSerial, isProductsWithSameSerialLoading } = useGetProductsBySerial(product)
    let width = isMobile ? '500px' : maxWidth

    if (isProductsWithSameSerialLoading) {
        return <LoadingSpinner />
    }
    if (!productsWithSameSerial || productsWithSameSerial.length === 0) {
        return null
    }
    return (
        <div style={{ maxWidth: width }}>
            <CustomSwiper
                products={productsWithSameSerial.slice(0, elementsInPage)}
                loop={false}
                refreshPage={false}
                autoPlay={false}
                isMobile={isMobile}
            />
        </div>
    )
}

